import React from "react";
import WebSS from "../../assets/webss.png";
import MobileSS from "../../assets/mobiless.png";

const Creators = () => {
  return (
    <div className="relative my-14">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 justify-between my-10 ">
        <div className="w-full  p-4 md:p-10">
          <p className="text-5xl font-semibold my-4">
            Fewer bots, zero gas wars.
          </p>
          <p>
            PREMINT lets you define exactly who is able to join your list. Allow
            everyone, or set eligibility requirements. It's all part of our
            effort to fill your list with real collectors, not bots.
          </p>
          <button className="bg-[color:var(--purple-color)] py-3 px-6 text-white mt-3 rounded-2xl">
            Learn More &nbsp; <i class="fa-solid fa-arrow-right-long"></i>
          </button>
        </div>
        <div className="w-full m-auto   relative">
          <img className=" w-full " src={WebSS} alt="" />
          <img
            className="absolute  w-1/3  lg:w-2/5 top-1/2 -translate-y-1/4 left-0 "
            src={MobileSS}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Creators;
